// Copyright (c) 2019 Sagacity Solutions Inc. All right reserved.
'use strict';

import { helpers } from '@vuelidate/validators'

const phonenumber$1 = helpers.regex(/^[+]?[0-9]?[-\s.]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/);

const phonenumber = {
  $validator: phonenumber$1,
  $message: 'This is not a correctly formatted phone number',
  $params: {
    type: 'phonenumber'
  }
}

export {
  phonenumber
}
